<template>
  <div
    class="flex flex-row items-center items-stretch rounded-lg text-neutral-500"
    :class="[type === 'error' ? 'bg-error-50' : type === 'warn' ? 'bg-warning-50' : 'bg-neutral-50']"
  >
    <div class="flex items-center">
      <font-awesome-icon
        class="px-6 text-center"
        :icon="['fas', type === 'info' ? 'circle-info' : 'circle-exclamation']"
      />
    </div>
    <div class="mt-2.5 mb-2.5 w-2 border-l-2" />
    <p class="p-3.5 text-xs">
      <slot />
    </p>
  </div>
</template>

<script setup lang="ts">
interface Props {
  type?: 'error' | 'warn' | 'info';
}

withDefaults(defineProps<Props>(), {
  type: 'info'
});
</script>
